<template>
  <svg class="icon" :class="props.class" :style="props.style">
    <use :xlink:href="`#icon-${props.icon}`" :href="`#icon-${props.icon}`" />
  </svg>
</template>
<script setup lang="ts">
type Props = {
  icon: string;
  class?: unknown;
  style?: unknown;
};
const props = defineProps<Props>();
</script>
